<template>
  <div class="SlideBodyText">
    <PortableText :value="blocks" />
  </div>
</template>

<script>
export default {
  props: {
    blocks: Array,
  },
}
</script>

<style scoped>
.SlideBodyText {
  font-weight: 400;
  font-size: var(--font-size-2);
  color: var(--text-color-white);
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-7);
}
.SlideBodyText:deep(strong) {
  font-weight: 600;
  font-size: var(--font-size-4);
}
.SlideBodyText:deep(ul) {
  list-style: disc;
  padding-left: 1.5rem;
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-6);
}
</style>
